/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addProductToSortiment } from '../fn/product-sortiments/add-product-to-sortiment';
import { AddProductToSortiment$Params } from '../fn/product-sortiments/add-product-to-sortiment';
import { deleteProductFromSortiment } from '../fn/product-sortiments/delete-product-from-sortiment';
import { DeleteProductFromSortiment$Params } from '../fn/product-sortiments/delete-product-from-sortiment';
import { deleteProductsFromSortiment } from '../fn/product-sortiments/delete-products-from-sortiment';
import { DeleteProductsFromSortiment$Params } from '../fn/product-sortiments/delete-products-from-sortiment';
import { getProductSortiment } from '../fn/product-sortiments/get-product-sortiment';
import { GetProductSortiment$Params } from '../fn/product-sortiments/get-product-sortiment';
import { getProductSortimentEntries } from '../fn/product-sortiments/get-product-sortiment-entries';
import { GetProductSortimentEntries$Params } from '../fn/product-sortiments/get-product-sortiment-entries';
import { getSortimentEntries } from '../fn/product-sortiments/get-sortiment-entries';
import { GetSortimentEntries$Params } from '../fn/product-sortiments/get-sortiment-entries';
import { getSortimentEntryById } from '../fn/product-sortiments/get-sortiment-entry-by-id';
import { GetSortimentEntryById$Params } from '../fn/product-sortiments/get-sortiment-entry-by-id';
import { PagedModelSiteSortimentEntryResponseModel } from '../models/paged-model-site-sortiment-entry-response-model';
import { PageProductSortimentEntryResponse } from '../models/page-product-sortiment-entry-response';
import { PageProductSortimentPageResponse } from '../models/page-product-sortiment-page-response';
import { ProductSortimentCreateResponse } from '../models/product-sortiment-create-response';
import { SiteSortimentEntryResponseModel } from '../models/site-sortiment-entry-response-model';
import { updateProductSortimentEntries } from '../fn/product-sortiments/update-product-sortiment-entries';
import { UpdateProductSortimentEntries$Params } from '../fn/product-sortiments/update-product-sortiment-entries';


/**
 * Product sortiment resource endpoints. A product sortiment entry (productSortimentId) represents a merchant's catalog decision to offer a specific product (packagingUnit). Each sortiment entry is further assigned to one or more merchant sites; each site assignment is a product sortiment entry (productSortimentEntryId) carrying site-specific pricing and availability. Use GET /site/{siteId}/products and GET /sortiment/{sortimentEntryId} to verify state after synchronization.
 */
@Injectable({ providedIn: 'root' })
export class ProductSortimentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getProductSortimentEntries()` */
  static readonly GetProductSortimentEntriesPath = '/sortiments/products/{prodSortId}/entries';

  /**
   * Gets site assignments for a product sortiment.
   *
   * Returns the site-level sortiment entries (productSortimentEntries) for the given productSortimentId. Each entry represents the product being offered at a specific site and includes site name, availability status, and the list of pricing segments that have been configured. Use this endpoint to verify site assignments after synchronization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSortimentEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductSortimentEntries$Response(params: GetProductSortimentEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSortimentEntryResponse>> {
    const obs = getProductSortimentEntries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets site assignments for a product sortiment.
   *
   * Returns the site-level sortiment entries (productSortimentEntries) for the given productSortimentId. Each entry represents the product being offered at a specific site and includes site name, availability status, and the list of pricing segments that have been configured. Use this endpoint to verify site assignments after synchronization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductSortimentEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductSortimentEntries(params: GetProductSortimentEntries$Params, context?: HttpContext): Observable<PageProductSortimentEntryResponse> {
    const resp = this.getProductSortimentEntries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductSortimentEntryResponse>): PageProductSortimentEntryResponse => r.body)
    );
  }

  /** Path part for operation `updateProductSortimentEntries()` */
  static readonly UpdateProductSortimentEntriesPath = '/sortiments/products/{prodSortId}/entries';

  /**
   * Updates site assignments for a product sortiment.
   *
   * Adds or removes site-level sortiment entries for the given productSortimentId. Use this to assign a product sortiment to additional sites or to change availability status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductSortimentEntries()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductSortimentEntries$Response(params: UpdateProductSortimentEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateProductSortimentEntries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates site assignments for a product sortiment.
   *
   * Adds or removes site-level sortiment entries for the given productSortimentId. Use this to assign a product sortiment to additional sites or to change availability status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProductSortimentEntries$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductSortimentEntries(params: UpdateProductSortimentEntries$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateProductSortimentEntries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addProductToSortiment()` */
  static readonly AddProductToSortimentPath = '/sortiments/products';

  /**
   * Adds a product to the merchant's sortiment.
   *
   * Creates a new product sortiment entry for the authenticated merchant, linking the specified packagingUnitId to the merchant's catalog. The same product cannot be added twice (idempotent per packagingUnit). Returns the new productSortimentId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProductToSortiment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProductToSortiment$Response(params: AddProductToSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductSortimentCreateResponse>> {
    const obs = addProductToSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds a product to the merchant's sortiment.
   *
   * Creates a new product sortiment entry for the authenticated merchant, linking the specified packagingUnitId to the merchant's catalog. The same product cannot be added twice (idempotent per packagingUnit). Returns the new productSortimentId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addProductToSortiment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProductToSortiment(params: AddProductToSortiment$Params, context?: HttpContext): Observable<ProductSortimentCreateResponse> {
    const resp = this.addProductToSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductSortimentCreateResponse>): ProductSortimentCreateResponse => r.body)
    );
  }

  /** Path part for operation `deleteProductsFromSortiment()` */
  static readonly DeleteProductsFromSortimentPath = '/sortiments/products';

  /**
   * Delete product sortiments.
   *
   * Deletes the given product sortiments
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProductsFromSortiment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProductsFromSortiment$Response(params: DeleteProductsFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteProductsFromSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete product sortiments.
   *
   * Deletes the given product sortiments
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProductsFromSortiment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProductsFromSortiment(params: DeleteProductsFromSortiment$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteProductsFromSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getProductSortiment()` */
  static readonly GetProductSortimentPath = '/sortiments/products/items';

  /**
   * Gets product sortiment list.
   *
   * Returns the paginated list of product sortiment entries for the authenticated merchant. Each entry includes the productSortimentId, the linked packagingUnitId, and pricing metadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSortiment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductSortiment$Response(params: GetProductSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSortimentPageResponse>> {
    const obs = getProductSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets product sortiment list.
   *
   * Returns the paginated list of product sortiment entries for the authenticated merchant. Each entry includes the productSortimentId, the linked packagingUnitId, and pricing metadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductSortiment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductSortiment(params: GetProductSortiment$Params, context?: HttpContext): Observable<PageProductSortimentPageResponse> {
    const resp = this.getProductSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductSortimentPageResponse>): PageProductSortimentPageResponse => r.body)
    );
  }

  /** Path part for operation `getSortimentEntryById()` */
  static readonly GetSortimentEntryByIdPath = '/sortiment/{sortimentEntryId}';

  /**
   * Gets a site sortiment entry by id.
   *
   * Returns the site-level sortiment entry identified by sortimentEntryId (productSortimentEntryId). Use this endpoint to verify a specific product's availability status and VAT rate at a site after synchronization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSortimentEntryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSortimentEntryById$Response(params: GetSortimentEntryById$Params, context?: HttpContext): Observable<StrictHttpResponse<SiteSortimentEntryResponseModel>> {
    const obs = getSortimentEntryById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a site sortiment entry by id.
   *
   * Returns the site-level sortiment entry identified by sortimentEntryId (productSortimentEntryId). Use this endpoint to verify a specific product's availability status and VAT rate at a site after synchronization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSortimentEntryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSortimentEntryById(params: GetSortimentEntryById$Params, context?: HttpContext): Observable<SiteSortimentEntryResponseModel> {
    const resp = this.getSortimentEntryById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SiteSortimentEntryResponseModel>): SiteSortimentEntryResponseModel => r.body)
    );
  }

  /** Path part for operation `getSortimentEntries()` */
  static readonly GetSortimentEntriesPath = '/site/{siteId}/products';

  /**
   * Lists sortiment entries for a site.
   *
   * Returns a paged list of all products (packagingUnits) in the sortiment of the given site, with availability status, VAT rate, EAN codes, and collection count. Use this endpoint to verify the complete product list for a site after synchronization. Accessible by TECHNICAL_USER, PRODUCT_ADMIN, and EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSortimentEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSortimentEntries$Response(params: GetSortimentEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelSiteSortimentEntryResponseModel>> {
    const obs = getSortimentEntries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists sortiment entries for a site.
   *
   * Returns a paged list of all products (packagingUnits) in the sortiment of the given site, with availability status, VAT rate, EAN codes, and collection count. Use this endpoint to verify the complete product list for a site after synchronization. Accessible by TECHNICAL_USER, PRODUCT_ADMIN, and EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSortimentEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSortimentEntries(params: GetSortimentEntries$Params, context?: HttpContext): Observable<PagedModelSiteSortimentEntryResponseModel> {
    const resp = this.getSortimentEntries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelSiteSortimentEntryResponseModel>): PagedModelSiteSortimentEntryResponseModel => r.body)
    );
  }

  /** Path part for operation `deleteProductFromSortiment()` */
  static readonly DeleteProductFromSortimentPath = '/sortiments/products/{prodSortId}';

  /**
   * Removes a product from the merchant's sortiment.
   *
   * Deletes the product sortiment entry identified by prodSortId, including all site-level sortiment entries and associated pricing.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProductFromSortiment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProductFromSortiment$Response(params: DeleteProductFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteProductFromSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes a product from the merchant's sortiment.
   *
   * Deletes the product sortiment entry identified by prodSortId, including all site-level sortiment entries and associated pricing.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProductFromSortiment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProductFromSortiment(params: DeleteProductFromSortiment$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteProductFromSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
